import { FC, useState } from 'react';
import { EditStateContext } from './EditStateContext';

export const EditStateProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [isEditingMedium, setIsEditingMedium] = useState(false);
  const [isEditingMessageTypeIds, setIsEditingMessageTypeIds] = useState(new Set<number>());

  const clearEditState = () => {
    setIsEditingMedium(false);
    setIsEditingMessageTypeIds(new Set<number>());
  };

  const isEditingMessageType = (id: number) => isEditingMessageTypeIds.has(id);

  const createSetIsEditingMessageType = (id: number) => (isEditing: boolean) => {
    if (isEditing) {
      setIsEditingMessageTypeIds((prev) => new Set(prev).add(id));
    } else {
      const next = new Set(isEditingMessageTypeIds);
      next.delete(id);
      setIsEditingMessageTypeIds(next);
    }
  };

  return (
    <EditStateContext.Provider
      value={{
        isEditingMedium,
        setIsEditingMedium,
        isEditingMessageType,
        createSetIsEditingMessageType,
        clearEditState,
      }}
    >
      {children}
    </EditStateContext.Provider>
  );
};
